import { Component, forwardRef, inject, input } from '@angular/core';
import { BaseModule } from '../../shared/base.module';
import { GoToDetailsDirective } from '../../shared/directives/go-to-details.directive';
import { ChatService } from '../chat.service';
import { catchError, EMPTY, first } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-chat-document',
  templateUrl: './chat-document.component.html',
  styleUrls: ['./chat-document.component.scss'],
  imports: [
    BaseModule,
  ]
})
export class ChatDocumentComponent {
  document = input.required<any>();

  chatService= inject(ChatService);

  snackBar = inject(MatSnackBar);

  goToDocumentChat() {
    this.chatService.addChat("Budget", this.document().id).pipe(
      first(),
      catchError(() => {
        this.snackBar.open(
          'Error al redireccinar al chat',
          'Cerrar',
          { duration: 3000, panelClass: 'snackbar-error' }
        );
        return EMPTY;
      }),
    ).subscribe();
  }
}
